import {
  TrendingUp,
  TrendingDown,
  Clock,
  BarChart3
} from "lucide-react";

export const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_61f9b4e5-9795-47b1-942b-e3ab1711fd8f/artifacts/jiw8ixlc_edensdad._cinematic_close-up_cross-view_of_luxury_British_home__aa4984b8-4df0-4c41-b9bc-f7261784d14d.png";

export const BAND_CONFIG = {
  "Negligible": { color: "text-gray-400", bg: "bg-gray-500/20", ring: "#6B7280", percent: 10, label: "Negligible", message: "Your property is well-optimised — growth will come from the market", meaning: "Property near ceiling. Appreciation will come from market, not improvements. Little to unlock." },
  "Low": { color: "text-amber-400", bg: "bg-amber-500/20", ring: "#F59E0B", percent: 30, label: "Limited", message: "Limited but focused improvement potential", meaning: "Some potential but limited scope. Focus on cosmetic and presentation improvements." },
  "Medium": { color: "text-cipher-gold", bg: "bg-cipher-gold/20", ring: "#C5A059", percent: 45, label: "Notable", message: "Real improvement potential identified", meaning: "Real potential. Targeted improvements could shift value meaningfully." },
  "High": { color: "text-cipher-green", bg: "bg-cipher-green/20", ring: "#006A4D", percent: 70, label: "Strong", message: "Strong potential for value creation", meaning: "Strong potential. Multiple strategies could unlock significant value." },
  "Exceptional": { color: "text-emerald-400", bg: "bg-emerald-500/20", ring: "#34D399", percent: 90, label: "Exceptional", message: "Transformational potential within your footprint", meaning: "Transformational potential. Category shift and major footprint reconfiguration possible." }
};

export const SCORE_DETAILS = {
  spatial_efficiency: {
    name: "Space Utilisation",
    description: "How much untapped space exists to reconfigure",
    explanation: "Your home has space that could be better used or reclaimed."
  },
  unlockability: {
    name: "Improvement Potential",
    description: "How many improvement options the property offers",
    explanation: "Your home has features that make improvements practical without major hassle."
  },
  market_alignment: {
    name: "Market Appeal",
    description: "How well improvements would be received locally",
    explanation: "Some improvements work better in your area than others."
  },
  comparison: {
    name: "Local Comparison",
    description: "How your home compares to similar ones nearby",
    explanation: "Your home scores higher than most similar properties — that's a good sign for potential value."
  },
  buyer_interest: {
    name: "Buyer Interest",
    description: "How much demand there is for homes like yours",
    explanation: "Buyers are actively looking for homes with features like yours."
  }
};

export const URGENCY_MESSAGES = {
  rising: { icon: TrendingUp, text: "Rising", desc: "Buyer interest increasing locally", color: "text-cipher-green", bg: "bg-cipher-green/20", border: "border-cipher-green/30" },
  stable: { icon: Clock, text: "Stable", desc: "Consistent activity in your area", color: "text-cipher-gold", bg: "bg-cipher-gold/20", border: "border-cipher-gold/30" },
  mixed: { icon: BarChart3, text: "Mixed", desc: "Variable conditions locally", color: "text-blue-400", bg: "bg-blue-500/20", border: "border-blue-500/30" }
};

export const DWELLING_NAMES = {
  "detached": "detached house",
  "semi-detached": "semi-detached",
  "semi_detached": "semi-detached",
  "terrace": "terraced house",
  "bungalow": "bungalow",
  "flat": "flat"
};

export const GOAL_OPPORTUNITIES = {
  "sell": "sale optimisation",
  "rent": "rental yield improvement",
  "add_space": "space expansion",
  "boost_value": "value enhancement"
};

export const UNLOCK_PRICE = 29;
